import React, { createContext, useState } from "react";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const default_theme = localStorage.getItem("5ktheme");
  const [mode, setMode] = useState(default_theme || "light");
  const toggleColorMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ toggleColorMode, mode }}>
      {children}
    </ThemeContext.Provider>
  );
};
